import { type Ref, onMounted, ref } from 'vue'

export const useDoubleTap = (element: Ref, callback: () => void) => {
  const doubleTaped = ref(false)

  onMounted(() => {
    element.value.addEventListener(
      'click',
      (event: MouseEvent | TouchEvent) => {
        event.preventDefault()

        if (!doubleTaped.value) {
          doubleTaped.value = true

          setTimeout(() => {
            doubleTaped.value = false
          }, 300)
          return
        }

        callback()
      }
    )
  })
}
